import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, Clock } from "lucide-react";
import PageHero from "@/components/PageHero";
import { BLOG, IMG } from "@/data/site";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

export default function Blog() {
  const [featured, ...rest] = BLOG;
  return (
    <div data-testid="blog-page">
      <PageHero
        title="Waterproofing Insights & Guides"
        subtitle="Expert advice for Jaipur homeowners and businesses — costs, monsoon protection, and how to choose the right waterproofing."
        image={IMG.rain}
        crumbs={[{ label: "Blog" }]}
      />

      <section className="bg-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <Reveal>
            <Link to={`/blog/${featured.slug}`} className="group grid lg:grid-cols-2 gap-8 items-center mb-16 bg-soft-grey rounded-lg overflow-hidden border border-slate-200">
              <div className="h-64 lg:h-full overflow-hidden">
                <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-8">
                <span className="text-xs font-semibold text-royal bg-royal/10 px-3 py-1 rounded-full">{featured.tag}</span>
                <h2 className="font-display text-3xl font-extrabold text-navy-deep mt-4 group-hover:text-royal transition-colors">{featured.title}</h2>
                <p className="text-slate-600 mt-3">{featured.excerpt}</p>
                <div className="flex items-center gap-4 text-xs text-slate-500 mt-4">
                  <span className="flex items-center gap-1"><Calendar className="h-3 w-3" />{featured.date}</span>
                  <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{featured.read}</span>
                </div>
                <span className="inline-flex items-center gap-1 text-royal font-semibold mt-5">Read article <ArrowUpRight className="h-4 w-4" /></span>
              </div>
            </Link>
          </Reveal>

          <Stagger className="grid md:grid-cols-3 gap-6">
            {rest.map((p) => (
              <StaggerItem key={p.slug}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-${p.slug}`} className="group block bg-white rounded-lg overflow-hidden border border-slate-200 h-full hover:-translate-y-1 hover:shadow-lg transition-all">
                  <div className="h-48 overflow-hidden">
                    <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  </div>
                  <div className="p-6">
                    <span className="text-xs font-semibold text-royal">{p.tag}</span>
                    <h3 className="font-display text-lg font-bold text-navy-deep mt-2 group-hover:text-royal transition-colors">{p.title}</h3>
                    <p className="text-slate-600 text-sm mt-2 line-clamp-2">{p.excerpt}</p>
                    <div className="flex items-center gap-3 text-xs text-slate-500 mt-4"><span className="flex items-center gap-1"><Calendar className="h-3 w-3" />{p.date}</span><span className="flex items-center gap-1"><Clock className="h-3 w-3" />{p.read}</span></div>
                  </div>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
}
